export const foodI18n = {
    'hu': {
        bride: [
            'Lecsókrém, savanyított zöldésgek VAGY Arancini, bazsalikom, házi paradicsomszósz',
            'Sült kápiakrémleves, metélőhagyma',
            'Cukkinifasírt, füstös burgonyakrém, ranch szósz',
            'Gombapörkölt, sajtos galuska, kovászos uborka'
        ],
        groom: [
            'Kacsamáj terrine, füge chutney, savanyított hagyma, fonott kalács',
            'Tyúkhúsleves zöldségekkel és házi csigatésztával',
            'Szarvasgombás mozzarella sajttal töltött csirkemell rusztikus morzsában, füstös burgonyakrém, répa chips VAGY Branzino, pácolt koktélparadicsom, égetett gyökérzöldségek, citrusos vajmártás',
            'Vörösboros szarvasragu, burgonya fánk, áfonya'
        ],
        titles: ['Előétel', 'Leves', 'Első fogás', 'Második fogás']
    },
    'en': {
        bride: [
            'Lecso cream, pickled vegetables OR Arancini, basil, homemade tomato sauce',
            'Roasted kapia pepper cream soup, chives',
            'Zucchini fritters, smoky potato cream, ranch sauce',
            'Mushroom stew, cheese dumplings, fermented cucumber'
        ],
        groom: [
            'Duck liver terrine, fig chutney, pickled onion, braided brioche',
            'Hen broth with vegetables and homemade csiga pasta',
            'Chicken breast stuffed with truffle mozzarella in rustic breadcrumbs, smoky potato cream, carrot chips OR Branzino, marinated cherry tomatoes, charred root vegetables, citrus butter sauce',
            'Red wine venison stew, potato doughnuts, blueberry'
        ],
        titles: ['Appetizer', 'Soup', 'First course', 'Second course']
    }
}
